import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroImg3 from '../components/HeroImg3';
import Form from '../components/form';

const Contact = () => {
  return (
    <div>
      <Navbar/>
    
      
      <HeroImg3/>
      <br></br>
      <Form/>
      <br></br>
      <Footer/>
    </div>
  )
}

export default Contact